import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';


// Define title mapping for different domains
const domainTitleMapping = {
  'skyexch99.art': 'SKYEXCH99 - Online Casino & Sports Betting',
  'betbuzz24.live': 'BETBUZZ24 - Online Casino & Sports Betting',
  'skyexch.sbs': 'SKYEXCH - Online Casino & Sports Betting',
};

// Get the current domain
const currentDomain = window.location.hostname;

// Set the document title dynamically
document.title = domainTitleMapping[currentDomain] || 'Online Casino & Sports Betting';

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);